
import { Appointment } from '@/types';
import { appointments as initialMockAppointments } from '../../data/mockData';

/**
 * Helper function to get mock appointments from localStorage
 */
export const getMockAppointments = (): Appointment[] => {
  const storedData = localStorage.getItem('mock_appointments');
  return storedData ? JSON.parse(storedData) : initialMockAppointments || [];
};

/**
 * Helper function to save mock appointments to localStorage
 */
export const saveMockAppointments = (appointments: Appointment[]): void => {
  localStorage.setItem('mock_appointments', JSON.stringify(appointments));
};
